import {Box, Button, Checkbox, FormControlLabel, Grid, Stack, TextField, Typography} from "@mui/material";
import React, {useState} from "react";
import {useApiManager} from "../../../../components/utils/api";
import {BillRestControllerApiFactory} from "arteco-api-client-ts";
import {fileLocalSave} from "../../../../components/form/form_inputs/form_file";
import {btnSx, Page, PageHeader, Panel} from "../../../../components/kit";


export const BillBatchPage = () => {
	const apiManager = useApiManager();
	const ctrl = apiManager.factory(BillRestControllerApiFactory);

	const [value, setValue] = useState<string>("");
	const [separator, setSeparator] = useState<string>("TAB");
	const [disabled, setDisabled] = useState<boolean>(false);
	const [sent, setSent] = useState<boolean>(true);
	const [simulate, setSimulate] = useState<boolean>(true);

	return (
		<Page>
			<PageHeader back="/app/admin/billing/bill" title="Facturas por lote"
						subtitle="Una factura por línea. Primero en simulación: descarga el resumen y, si cuadra, quita la simulación."/>

			<Grid container spacing={3}>
				<Grid item xs={12} md={8}>
					<Panel>
						<Stack direction="row" spacing={2} alignItems="center" sx={{mb: 2}} flexWrap="wrap" useFlexGap>
							<TextField
								label={"Separador"}
								size="small"
								sx={{width: 120}}
								autoComplete={"off"}
								value={separator}
								onChange={(event) => setSeparator(event.target.value)}
							/>
							<FormControlLabel control={<Checkbox checked={sent} onChange={_ => setSent(!sent)}/>}
											  label="Marcar como enviadas"/>
							<FormControlLabel control={<Checkbox checked={simulate} onChange={(event) => setSimulate(event.target.checked)}/>}
											  label="Simulación"/>
						</Stack>

						<TextField
							label={"Una factura por línea"}
							type={"text"}
							rows={18}
							multiline={true}
							fullWidth
							autoComplete={"off"}
							value={value}
							InputProps={{sx: {fontFamily: "monospace", fontSize: 13}}}
							onChange={(event) => setValue(event.target.value)}
						/>

						<Stack direction="row" spacing={1.5} alignItems="center" sx={{mt: 2}}>
							<Button
								variant={"contained"}
								sx={{...btnSx, px: 3}}
								disabled={disabled}
								onClick={() => {
									setDisabled(true);
									apiManager
									.executeRaw(ctrl.batchCreateBill(value, sent, separator, simulate))
									.then(summary => {
										fileLocalSave(summary);
										if (simulate) {
											setDisabled(false);
										}
									})
									.catch(reason => {
										alert(reason);
										setDisabled(false);
									});
								}}>
								{simulate ? "Simular" : "Crear facturas"}
							</Button>
							<Typography variant="caption" color={simulate ? "text.secondary" : "warning.dark"}>
								{simulate ? "No se crea nada: solo se descarga el resumen." : "Se crean las facturas de verdad."}
							</Typography>
						</Stack>
					</Panel>
				</Grid>

				<Grid item xs={12} md={4}>
					<Panel title="Formato">
						<Box sx={{p: 1.5, borderRadius: 2, bgcolor: "grey.50", border: "1px solid", borderColor: "divider",
							fontFamily: "monospace", fontSize: 12, wordBreak: "break-word"}}>
							{`id_cliente OR name ${separator} dd/mm/yyyy ${separator} descripción_factura ${separator} descripción_línea ${separator} cantidad ${separator} importe_unitario (€)`}
						</Box>
						<Typography variant="subtitle2" fontWeight={700} sx={{mt: 2}}>Notas</Typography>
						<Box component="ul" sx={{pl: 2.5, m: 0, mt: 0.5, "& li": {fontSize: 14, color: "text.secondary", mb: 0.5}}}>
							<li>Si las líneas coinciden en [cliente, fecha y descripción] se unificarán en la misma factura</li>
							<li>Las cantidades han de ir con decimales separados por punto '.'</li>
							<li>Las comas ',' serán reemplazadas por '.'</li>
							<li>Si hay más de dos puntos, se lanzará error</li>
						</Box>
					</Panel>
				</Grid>
			</Grid>
		</Page>
	);
}
